import { render, staticRenderFns } from "./ActsDetail.vue?vue&type=template&id=3bace82b&scoped=true"
import script from "./ActsDetail.vue?vue&type=script&lang=js"
export * from "./ActsDetail.vue?vue&type=script&lang=js"
import style0 from "./ActsDetail.vue?vue&type=style&index=0&id=3bace82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bace82b",
  null
  
)

export default component.exports